<template>
  <div>
    <role-info
      :serverId="serverId"
      v-show="serverId && roleId && roleId != -1 && needShowTopRole"
    ></role-info>
    <section-title
      :title="letter.storeRoleTitle"
      class="choose-role-title"
    ></section-title>
    <select-login-way
      v-show="!isLogin && !isUidLogin && !isUidTokenLogin"
    ></select-login-way>
    <normal-login
      v-if="isLogin && !isUidLogin"
      @updateShowTopRole="updateShowTopRole"
    ></normal-login>
    <uid-login
      v-if="isUidLogin"
      @updateShowTopRole="updateShowTopRole"
    ></uid-login>
    <uid-token-login
      v-if="!isLogin && isUidTokenLogin"
      :needInputUid="needInputUid"
      :uidNum="uidNum"
    ></uid-token-login>
  </div>
</template>

<script>
import SelectLoginWay from '@components/officialStore/login/SelectLoginWay.vue';
import NormalLogin from '@components/officialStore/login/NormalLogin.vue';
import UidLogin from '@components/officialStore/login/UidLogin.vue';
import UidTokenLogin from '@components/officialStore/login/UidTokenLogin.vue';
import RoleInfo from '@components/officialStore/login/RoleInfo.vue';
import SectionTitle from '@components/officialStore/SectionTitle.vue';
import login from '@mixins/officialStore/login';
import userStatus from '@mixins/officialStore/userStatus';

export default {
  name: 'selectRole',
  mixins: [login, userStatus],
  data() {
    return {
      needShowTopRole: false
    };
  },
  methods: {
    updateShowTopRole(isShow) {
      this.needShowTopRole = isShow;
    }
  },
  computed: {
    needInputUid() {
      return ![2].includes(+this.gameId);
    },
    uidNum() {
      return [2].includes(+this.gameId) ? 6 : 4;
    }
  },
  components: {
    SelectLoginWay,
    NormalLogin,
    UidLogin,
    UidTokenLogin,
    RoleInfo,
    SectionTitle
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialStore/officialStore.scss';
.choose-role-title {
  // margin: -97px auto 33px;
  margin: -57px auto 33px;
}
</style>
